import '../styles/Tranches.css';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTrashAlt } from 'react-icons/fa';
import { API } from '../config/api';

export default function Tranches() {
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [tranches, setTranches] = useState([]);
  const [form, setForm] = useState({ min: '', max: '', prix: '' });
  const token = localStorage.getItem('token');

  const fetchTranches = async () => {
    try {
      const res = await axios.get(API+'/api/tranches', {
        headers: { Authorization: `Bearer ${token}` },
      });
      setTranches(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('Erreur chargement tranches:', err);
      setTranches([]);
    }
  };

  useEffect(() => {
    fetchTranches();
  }, []);

  const filtered = (Array.isArray(tranches) ? tranches : []).filter(t =>
    t.valeurmin?.toString().includes(search) || t.valeurmax?.toString().includes(search)
  );

  const handleSubmit = async e => {
    e.preventDefault();
    const min = parseInt(form.min);
    const max = parseInt(form.max);
    const prix = parseFloat(form.prix);

    const lastMax = (Array.isArray(tranches) && tranches.length) ? tranches[tranches.length - 1].valeurmax : -1;

    if (min <= lastMax) {
      alert(`❌ La valeur min doit être > ${lastMax}`);
      return;
    }

    try {
      await axios.post(API+'/api/tranches', { min, max, prix }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchTranches();
      setShowModal(false);
      setForm({ min: '', max: '', prix: '' });
    } catch (err) {
      console.error('Erreur création tranche:', err);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Supprimer cette tranche ?")) return;
    try {
      await axios.delete(API+`/api/tranches/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchTranches();
    } catch (err) {
      console.error('Erreur suppression tranche:', err);
    }
  };

  return (
    <div className="tranche-page">
      <h1>Gestion des Tranches Tarifaires</h1>

      <div className="tranche-header">
        <input
          type="text"
          placeholder="Rechercher min/max..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <button className="tranche-btn-add" onClick={() => setShowModal(true)}>+ Ajouter Tranche</button>
      </div>

      <table className="tranche-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Valeur Min</th>
            <th>Valeur Max</th>
            <th>Prix (MAD / m³)</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {filtered.map((t, i) => (
            <tr key={i}>
              <td><strong>Tranche {i + 1}</strong></td>
              <td>{t.valeurmin}</td>
              <td>{t.valeurmax}</td>
              <td>{t.prix.toFixed(2)} MAD</td>
              <td><button onClick={() => handleDelete(t.idtranch)}><FaTrashAlt /></button></td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div className="tranche-modal-overlay">
          <div className="tranche-modal">
            <h2>Ajouter une Tranche</h2>
            <form onSubmit={handleSubmit}>
              <input name="min" type="number" placeholder="Valeur min" value={form.min} onChange={e => setForm({ ...form, min: e.target.value })} required />
              <input name="max" type="number" placeholder="Valeur max" value={form.max} onChange={e => setForm({ ...form, max: e.target.value })} required />
              <input name="prix" type="number" step="0.01" placeholder="Prix (MAD/m³)" value={form.prix} onChange={e => setForm({ ...form, prix: e.target.value })} required />
              <div className="tranche-modal-actions">
                <button type="submit">Enregistrer</button>
                <button type="button" onClick={() => setShowModal(false)}>Annuler</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <footer className="page-footer">
        <p>© 2025 Abar. Powered by <strong>Jysser Connect</strong></p>
      </footer>
    </div>
  );
}
